import React from "react";
import "./Qualifications.css";

const qualifications = [
  {
    titleL: "Master's in Psychology",
    placeL: "Central Department of Psychology, Tribhuvan University",
  },
  {
    titleL: "Gestalt Psychotherapy",
    placeL: "Gestalt Institute Nepal",
  },
  {
    titleL: "Somatic Experiencing Therapy",
    placeL: "Somatic Experiencing Nepal",
  },
  {
    titleL: "PGD – Dance Movement Therapy",
    placeL: "Sancheti Health Care Academy",
  },
  {
    titleL: "Group Psychotherapy",
    placeL: "Himal Partner & Nepalese Association of Clinical Psychologists",
  },
  {
    titleL: "PGD – Yog Science",
    placeL: "Central Department of Sanskrit, Tribhuvan University",
  },
  {
    titleL: "Advanced EMDR Trauma Training",
    placeL: "Antardristi Counseling Center & Innovative Counselling Partners",
  },
  {
    titleL: "Gestalt Supervisor Training Program",
    placeL: "Gestalt Institute Nepal",
  },
  {
    titleR: "Yoga Teacher's Training - USA Yoga Alliance Certification (RYT - 500 hrs)",
    placeR: "Shiva Tattva Yog School",
  },
  {
    titleR: "Reiki Healing",
    placeR: "Rainbow Healing Nepal",
  },
  {
    titleR: "Tibetian Sound Healing",
    placeR: "Shiva Tattva Yog School",
  },
  {
    titleR: "Advanced Sand Play Therapy",
    placeR: "Ankur Counseling Centre",
  },
  {
    titleR: "Art Therapy – The Creative Studio: Peacemaker Exercise",
    placeR: "Central Department of Psychology, Tribhuvan University",
  },
  {
    titleR: "Couple Counseling Training.",
    placeR: "Elijah Counselling and Training Centre",
  },
  {
    titleR: "Trauma Informed Care",
    placeR: "Transformation Catalyst",
  },
];

const Qualifications = () => {
  const leftItems = qualifications.filter((q) => q.titleL);
  const rightItems = qualifications.filter((q) => q.titleR);
  const maxLength = Math.max(leftItems.length, rightItems.length);

  return (
    <section id="qualifications" className="qualifications-section">
      <h2>Skills & Qualifications</h2>
      <div className="qualification-table-container">
        <table className="qualification-table">
          <tbody>
            {Array.from({ length: maxLength }).map((_, index) => (
              <tr key={index}>
                <td>{leftItems[index]?.titleL || ""}</td>
                <td>{leftItems[index]?.placeL || ""}</td>
                <td className="center-column"></td>
                <td>{rightItems[index]?.titleR || ""}</td>
                <td>{rightItems[index]?.placeR || ""}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default Qualifications;
